<template>
  <validation-observer v-slot="{invalid}" slim>
    <g-page-wrapper>
      <template slot="pageTitle">
        <g-page-title :title="$t('pages_product_ProductEdit.1')" :paths="paths"></g-page-title>
      </template>
      <g-contents v-if="selectProductInfo.stratCode">
        <div class="-wrapper -bg-white -pb-10 -px-5 -pt-5">
          <div class="-font-size-12 mw-800 -width-100">
            <div class="-wrapper-half">
              <g-input-text-label :label="$t('pages_product_ProductInfo.title.1')" star class="-pr-5">
                <g-dropdown id="product-productedit-g-dropdown-01" dropdownType="button" v-model="info.stratNameLv1" variant="secondary" class="-width-100" disabled>
                  <g-dropdown-item-wrap>
                    <g-dropdown-item :text="selectProductInfo.stratNameLv1 || ''" :value="selectProductInfo.stratNameLv1 || ''"></g-dropdown-item>
                  </g-dropdown-item-wrap>
                </g-dropdown>
              </g-input-text-label>
              <g-input-text-label :label="$t('pages_product_ProductInfo.title.2')" star>
                <g-dropdown id="product-productedit-g-dropdown-02" dropdownType="button" v-model="info.stratNameLv2" variant="secondary" class="-width-100" disabled>
                  <g-dropdown-item-wrap>
                    <g-dropdown-item :text="selectProductInfo.stratNameLv2 || ''" :value="selectProductInfo.stratNameLv2 || ''"></g-dropdown-item>
                  </g-dropdown-item-wrap>
                </g-dropdown>
              </g-input-text-label>
            </div>


            <g-input-text-label :label="$t('pages_product_ProductInfo.title.3')" star class="-mt-8">
              <g-dropdown id="product-productedit-g-dropdown-03" dropdownType="button" v-model="info.category" variant="secondary" class="-width-100" disabled>
                <g-dropdown-item-wrap>
                  <g-dropdown-item :text="selectProductInfo.category || ''" :value="selectProductInfo.category || ''"></g-dropdown-item>
                </g-dropdown-item-wrap>
              </g-dropdown>
            </g-input-text-label>


            <g-input-text-label :label="$t('pages_product_ProductInfo.title.4')" star class="-mt-8">
              <g-input-text id="product-productedit-g-input-text-01" class="-width-100" v-model="info.productName" disabled></g-input-text>
            </g-input-text-label>

            <g-input-text-label :label="$t('pages_product_ProductInfo.title.5')" star class="-mt-8">
              <validation-provider
                name="remark"
                rules="required"
                v-slot={invalid}
                slim>
                <textarea id="product-productedit-textarea-01" class="-input -width-100" :invalid="invalid" v-model="info.remark" rows="6"></textarea>
              </validation-provider>
            </g-input-text-label>

            <div class="-mt-6">
              <div class="-wrapper v-center-">
                <g-switch id="product-productedit-g-switch-01" :text="$t('pages_product_ProductInfo.title.6')" class="-mr-18" :checked="info.isNew === 'Y'" @change="onChangeNew"/>
                <g-switch id="product-productedit-g-switch-02" :text="$t('pages_product_ProductInfo.title.7')" class="-mr-18" :checked="info.stat === 'Y'" @change="onChangeStat"/>
              </div>
            </div>

            <g-input-text-label :label="$t('pages_product_ProductInfo.title.8')" star class="-mt-8">
              <div class="-wrapper-half">
                <g-input-text id="product-productedit-g-input-text-02" class="-width-100 " disabled :value="managerName"></g-input-text>
                <div class="-pl-2">
                  <g-button id="product-productedit-g-button-01" variant="secondary" @click="onClickChangeManager">
                    <span>{{$t('pages_product_ProductEdit.2')}}</span>
                  </g-button><!--
                  --><g-button id="product-productedit-g-button-02" variant="secondary" @click="onClickResetManager">
                    <span>{{$t('common.reset')}}</span>
                  </g-button>
                </div>
              </div>
            </g-input-text-label>

            <g-input-text-label :label="$t('pages_product_ProductInfo.title.9')" class="-mt-8">
              <div class="-wrapper-half">
                <g-input-text id="product-productedit-g-input-text-03" class="-width-50" type="text" v-model="info.lastUpdateDate" disabled></g-input-text>
              </div>
            </g-input-text-label>

            <g-input-text-label :label="$t('pages_product_ProductEdit.file.1')" class="-mt-8">
              <g-upload-file
                id="product-productedit-g-upload-file-01"
                :uploadFileList="file.brochure.fileList"
                :extensionList='EXTENSTION_LIST'
                :progress="file.brochure.progress"
                :file-info="file.brochure.info"
                :maxLen="1"
                :cancel-text="$t('common.cancel')"
                @change-file-list="onDropFile(PRODUCT_FILE_TYPES.BROCHURE, $event)"
                @delete-item="onClickFileDelete(PRODUCT_FILE_TYPES.BROCHURE, $event)"
                @error="onUploadFileError">
                <template #findFile>
                  <g-icon name="publish" color="gray-1"></g-icon>
                  <span class="-color-darkgray-1">{{$t('common.file.1')}}</span>
                  <span class="-border-color-blue-1">{{$t('common.file.2')}}</span>
                </template>
              </g-upload-file>
            </g-input-text-label>

            <g-input-text-label :label="$t('pages_product_ProductEdit.file.2')" class="-mt-8" >
              <g-upload-file
                id="product-productedit-g-upload-file-02"
                :uploadFileList.sync="file.intro.fileList"
                :extensionList='EXTENSTION_LIST'
                :progress="file.intro.progress"
                :file-info="file.intro.info"
                :maxLen="1"
                :cancel-text="$t('common.cancel')"
                @change-file-list="onDropFile(PRODUCT_FILE_TYPES.INTRO, $event)"
                @delete-item="onClickFileDelete(PRODUCT_FILE_TYPES.INTRO, $event)"
                @error="onUploadFileError">
                <template #findFile>
                  <g-icon name="publish" color="gray-1"></g-icon>
                  <span class="-color-darkgray-1">{{$t('common.file.1')}}</span>
                  <span class="-border-color-blue-1">{{$t('common.file.2')}}</span>
                </template>
              </g-upload-file>
            </g-input-text-label>

            <g-input-text-label :label="$t('pages_product_ProductEdit.file.3')" class="-mt-8">
              <g-upload-file
                id="product-productedit-g-upload-file-03"
                :uploadFileList.sync="file.etc.fileList"
                :extensionList='EXTENSTION_LIST'
                :maxLen="1"
                :progress="file.etc.progress"
                :file-info="file.etc.info"
                :cancel-text="$t('common.cancel')"
                @change-file-list="onDropFile(PRODUCT_FILE_TYPES.ETC, $event)"
                @delete-item="onClickFileDelete(PRODUCT_FILE_TYPES.ETC, $event)"
                @error="onUploadFileError">
                <template #findFile>
                  <g-icon name="publish" color="gray-1"></g-icon>
                  <span class="-color-darkgray-1">{{$t('common.file.1')}}</span>
                  <span class="-border-color-blue-1">{{$t('common.file.2')}}</span>
                </template>
              </g-upload-file>
            </g-input-text-label>

            <p class="-description -mt-2">{{$t('pages_product_ProductEdit.3')}}</p>
          </div>
        </div>
        <div class="fixed-bot-menu -border-top -width-100  -py-2 -wrapper end- -bg-white">
          <div class="-mr-5">
            <g-button id="product-productedit-g-button-03" variant="borderless" size="large" @click="onClickCancel">
              <span>{{$t('common.cancel')}}</span>
            </g-button><!--
            --><g-button id="product-productedit-g-button-04" class="-bg-blue-1 -mr-0" @click="onClickSave" :disabled="invalid || !isUploading">
              <span class="-color-white">{{$t('common.save')}}</span>
            </g-button>
          </div>
        </div>
      </g-contents>
    </g-page-wrapper>
  </validation-observer>
</template>

<script>
import { cloneDeep } from 'loadsh'
import { mapActions, mapGetters } from 'vuex'
import CodeGroupId from '@/code/CodeGroupId'
import CodeCreate from  '@/code/CodeCreate'
import {PRODUCT_FILE_TYPES, EXTENSTION_LIST} from '@/code/CodeProduct'
import CompanyPopup from '@/pages/components/CompanyPopup'
import {FileUploader} from '@/library/FileUploader'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import GDatePicker from '@/pages/components/GDatePicker'

export default {
  name: 'product-edit',
  componentName: 'ProductEdit',
  components: {ValidationProvider, ValidationObserver, GDatePicker},
  data () {
    return {
      paths: [{
        path: '/product/list',
        name: this.$t('pages_product_ProductList.1')
      }, {
        path: `/product/info?stratCode=${this.$route.query.stratCode}`,
        name: this.$t('pages_product_ProductInfo.1')
      }, {
        name: this.$t('pages_product_ProductEdit.1')
      }],
      info: {},
      file: {
        brochure: {
          fileList: [],
          progress: {},
          info: {}
        },
        intro: {
          fileList: [],
          progress: {},
          info: {}
        },
        etc: {
          fileList: [],
          progress: {},
          info: {}
        },
      },
      selectedManager: {},
      PRODUCT_FILE_TYPES: PRODUCT_FILE_TYPES,
      EXTENSTION_LIST: EXTENSTION_LIST
    }
  },
  computed: {
    ...mapGetters('product', ['selectProductInfo', 'codeProductUpdate', 'codeProductFileUpdate', 'codeSelectProductInfo']),
    ...mapGetters('user', ['userInfo']),
    managerName () {
      return this.selectedManager.userName || this.info.userName
    },
    isUploading () {
      const progressList = Object.values(this.file).map(item => item.progress)
      const isUpload = progressList.reduce((acc, cur) => {
        return [...acc, ...Object.values(cur).map(item => item.value)]
      }, [])
      return isUpload.every((element) => element === 100)
    }
  },
  methods : {
    ...mapActions('product', [
      'getSelectProductInfo', 'updateProductInfo', 'clearSelectProductInfo',
      'deleteFile', 'getUploadedFiles', 'updateProductInfoFile', 'clearDeleteFile', 'addDeleteFile']),
    ...mapActions('customer', ['getCompanyList']),
    ...mapActions('code', ['getCommonCodeGroupDetail']),
    onChangeNew (e) {
      this.info.isNew = e ? 'Y' : 'N'
    },
    onChangeStat (e) {
      this.info.stat = e ? 'Y' : 'N'
    },
    onClickChangeManager () {
      const selectedManagerId = this.selectedManager.userEmail ? this.selectedManager.userEmail : this.info.userId
      this.$popupManager.open(CompanyPopup, {
        onSend: (selectedValue) => {
          this.selectedManager = selectedValue
        },
        selectedManagerId
      })
    },
    onClickResetManager () {
      this.selectedManager = {}
    },
    onClickSave () {
      this.updateProduct()
    },
    onDropFile (name, e) {
      const file = e[e.length - 1]
      const fileUploader = new FileUploader(
        {
          file,
          fileFolderPath: 'products',
          upload: this.uploadCallback,
          end: this.endCallback
        }
      )
      this.file[name].fileList = e.slice(e.length - 1, e.length)
      fileUploader.upload({name})
    },
    uploadCallback (info) {
      const {chunkedCount, index, params, file} = info

      this.$set(this.file[params.name], 'progress', {
        ...this.file[params.name].progress,
        [info.id]: {
          type: 'basic',
          value: index / chunkedCount * 100,
        }
      })
      this.$set(this.file[params.name], 'info', {
        ...this.file[params.name].info,
        [info.id]:{
          ...info
        }
      })

      if (info.id && this.file[params.name].fileList.filter(item => item.id === info.id).length === 0) {
        const fileList = this.file[params.name].fileList.reduce((acc, cur) => {
          if (cur.blob === info.file) {
            cur.id = info.id
          }
          return [...acc, cur]
        }, [])
        this.file[params.name].fileList = fileList
      }

    },
    endCallback (info) {
      this.uploadCallback(info)
      this.$showToast(this.$t('common.file_save'))
    },
    onClickFileDelete (fileType, id) {
      const {info, fileList} = this.file[fileType]
      this.file[fileType].fileList = fileList.filter(item => item.id !== id)

      this.addDeleteFile({
        id: id,
        stratCode: this.$route.query.stratCode,
        type: fileType
      })
      delete this.file[fileType].info[file.id]
      delete this.file[fileType].progress[file.id]
      this.info[`${fileType}FileId`] = null
      this.$showToast(this.$t('common.file_delete'))
    },
    getFileInfo (fileType) {
      let result = []
      for (let file of this.file[fileType].fileList) {
        result.push(this.file[fileType].info[file.id])
      }
      return result
    },
    updateProduct() {
      const productInfo = {
        ...this.info,
        ...this.selectedManager,
        userId: this.selectedManager.userEmail,
        file: {
          brochure: this.getFileInfo(PRODUCT_FILE_TYPES.BROCHURE),
          intro: this.getFileInfo(PRODUCT_FILE_TYPES.INTRO),
          etc: this.getFileInfo(PRODUCT_FILE_TYPES.ETC)
        }
      }
      this.updateProductInfo({productInfo})
    },
    updateProductFile () {
      const productInfo = {
        file: {
          brochure: this.getFileInfo(PRODUCT_FILE_TYPES.BROCHURE),
          intro: this.getFileInfo(PRODUCT_FILE_TYPES.INTRO),
          etc: this.getFileInfo(PRODUCT_FILE_TYPES.ETC)
        }
      }
      this.updateProductInfoFile({productInfo})
    },
    onClickCancel () {
      this.$router.go(-1)
    },
    onUploadFileError (error) {
      if('OVERFLOW_FILE_SIZE' === error){
        this.$showToast(this.$t('pages_notice_file.over_size'))
      } else if('NOT_ALLOW_EXTENSTION' === error){
        this.$showToast(this.$t('pages_notice_file.not_allow_extenstion'))
      } else if('MAX_LEN_OVER' === error) {
        this.$showToast(this.$t('common.file_uploading'))
      } else{
        this.$showToast(this.$t('pages_notice_file.error'))
      }
    }
  },

  watch: {
    selectProductInfo: {
      handler () {
        if (!this.info.stratCode) {
          this.info = cloneDeep(this.selectProductInfo)
        } else {
          this.info.brochureFileId = this.selectProductInfo.brochureFileId
          this.info.introFileId = this.selectProductInfo.introFileId
          this.info.etcFileId = this.selectProductInfo.etcFileId
        }
        const brochureFileId = this.info.brochureFileId
        const introFileId = this.info.introFileId
        const etcFileId = this.info.etcFileId
        if (brochureFileId) {
          this.file.brochure.fileList = [{name: this.info.brochureFileName, size: this.info.brochureFileSize, id: brochureFileId}]
          this.file.brochure.info = {
            [brochureFileId]:{
              preview: `${location.origin}/api/v1/files/${brochureFileId}`,
              id: brochureFileId,
              uploadDate: this.info.brochureFileCreated
            }
          }
        }
        if (introFileId) {
          this.file.intro.fileList = [{name: this.info.introFileName, size: this.info.introFileSize, id: introFileId}]
          this.file.intro.info = {
            [introFileId]: {
              preview: `${location.origin}/api/v1/files/${introFileId}`,
              id: introFileId,
              uploadDate: this.info.introFileCreated
            }
          }
        }
        if (etcFileId) {
          this.file.etc.fileList = [{name: this.info.etcFileName, size: this.info.etcFileSize, id: etcFileId}]
          this.file.etc.info = {
            [etcFileId]: {
              preview: `${location.origin}/api/v1/files/${etcFileId}`,
              id: etcFileId,
              uploadDate: this.info.etcFileCreated
            }
          }
        }
      },
      immediate: true
    },
    codeProductUpdate : {
      handler () {
        if (this.codeProductUpdate === CodeCreate.SUCCESS) {
          this.$showToast(this.$t('pages_product_ProductEdit.message.1'))
          this.$router.push(`/product/info?stratCode=${this.$route.query.stratCode}`)
        }
      }
    },
    codeProductFileUpdate: {
      handler () {
        if (this.codeProductUpdate === CodeCreate.SUCCESS) {
          this.$showToast(this.$t('pages_product_ProductEdit.message.1'))
        }
      }
    },
    codeSelectProductInfo: {
      handler () {
        if (this.codeSelectProductInfo === CodeCreate.EXCEPTION) {
          this.$router.go(-1)
        }
      }
    }
  },
  beforeMount () {
    const stratCode = this.$route.query.stratCode
    this.getSelectProductInfo(stratCode)
    this.getCommonCodeGroupDetail({codeGroupId: CodeGroupId.PRODUCT_CATEGORY})
    this.getCompanyList()
    this.clearDeleteFile()
  },
  beforeDestroy () {
    this.clearSelectProductInfo()
    this.clearDeleteFile()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/ProductEdit.vue